const renderSettingsText = () => {
    return <div />;
};
export default renderSettingsText;
